export const treatments = [
  {
    slug: 'general-dental-checkup',
    title: 'General Dental Checkup',
    shortDescription:
      'Comprehensive oral examinations to assess your overall dental health and detect issues early.',
    image: '/services/general_dental_checkup.png',
    heroTitle: 'General Dental Checkup in Muzaffarpur',
    heroDescription:
      'Preventive checkups help identify cavities, gum concerns, and bite issues before they become serious. Our clinic follows a systematic exam process for long-term oral health.',
    overview:
      'A routine dental checkup includes oral examination, gum assessment, cavity screening, and preventive guidance. It is the foundation of healthy teeth and gums at every age.',
    benefits: [
      'Early detection of cavities and gum disease',
      'Lower risk of costly future treatments',
      'Improved oral hygiene habits and confidence',
      'Professional cleaning recommendations',
    ],
    processSteps: [
      'Clinical exam and oral history review',
      'Gum health and cavity risk assessment',
      'X-ray recommendations when needed',
      'Preventive plan and follow-up advice',
    ],
    duration: '30 to 60 minutes',
    frequency: 'Every 6 months',
    faqs: [
      {
        question: 'How often should I visit for a checkup?',
        answer: 'Most patients benefit from a checkup every six months.',
      },
      {
        question: 'Do children also need regular checkups?',
        answer: 'Yes, children should have regular preventive visits for early dental guidance.',
      },
    ],
  },
  {
    slug: 'dental-fillings',
    title: 'Dental Fillings',
    shortDescription:
      'Tooth-colored restorative fillings to repair decay, strengthen teeth, and restore function.',
    image: '/services/dental_fillings.png',
    heroTitle: 'Dental Fillings for Cavity Treatment',
    heroDescription:
      'We use modern composite filling materials that blend naturally with your tooth shade and preserve healthy tooth structure.',
    overview:
      'Dental fillings are used to restore teeth affected by decay or minor fractures. Prompt treatment prevents deeper infection and helps preserve your natural teeth.',
    benefits: [
      'Stops cavity progression quickly',
      'Natural looking restoration',
      'Improves chewing comfort',
      'Protects tooth from further damage',
    ],
    processSteps: [
      'Diagnosis and treatment planning',
      'Removal of decayed tooth structure',
      'Composite filling placement and shaping',
      'Bite adjustment and finishing polish',
    ],
    duration: '30 to 60 minutes per tooth',
    frequency: 'As advised after diagnosis',
    faqs: [
      {
        question: 'Are tooth-colored fillings durable?',
        answer: 'Yes, modern composite fillings are strong and long-lasting with proper care.',
      },
      {
        question: 'Will filling treatment be painful?',
        answer: 'The procedure is done with comfort measures and is generally well tolerated.',
      },
    ],
  },
  {
    slug: 'orthodontics-braces-aligners',
    title: 'Teeth Alignment Orthodontics',
    shortDescription:
      'Braces and clear aligners to correct misaligned teeth and improve smile aesthetics and bite function.',
    image: '/services/teeth_allign.png',
    heroTitle: 'Braces and Clear Aligners in Muzaffarpur',
    heroDescription:
      'Our orthodontic treatment plans are customized for children, teens, and adults to improve alignment, oral hygiene, and facial balance.',
    overview:
      'Orthodontic treatment helps correct crooked teeth, crowding, spacing, and bite irregularities. We evaluate your case and recommend braces or aligners based on goals and complexity.',
    benefits: [
      'Straighter smile and improved confidence',
      'Better bite and jaw balance',
      'Easier cleaning and lower cavity risk',
      'Long-term oral health improvements',
    ],
    processSteps: [
      'Orthodontic consultation and records',
      'Treatment plan with braces or aligners',
      'Regular adjustment and progress visits',
      'Retention phase to maintain results',
    ],
    duration: '12 to 24 months in most cases',
    frequency: 'Follow-up every 4 to 8 weeks',
    faqs: [
      {
        question: 'How do I choose between braces and aligners?',
        answer: 'Choice depends on complexity, lifestyle, and clinical suitability.',
      },
      {
        question: 'Can adults start orthodontic treatment?',
        answer: 'Yes, orthodontic care is effective for adults as well.',
      },
    ],
  },
  {
    slug: 'dental-implants',
    title: 'Dental Implants',
    shortDescription:
      'Permanent tooth replacement options that look natural and restore chewing confidence.',
    image: '/services/dental_implant.png',
    heroTitle: 'Dental Implants for Missing Teeth',
    heroDescription:
      'Dental implants are a fixed solution for missing teeth, designed to support crowns and restore both function and smile aesthetics.',
    overview:
      'An implant is a titanium root replacement placed in the jawbone, followed by a custom restoration. It provides stable and long-term tooth replacement.',
    benefits: [
      'Natural look and feel',
      'Supports chewing and speech',
      'Preserves jawbone structure',
      'Long-term restoration option',
    ],
    processSteps: [
      'Clinical evaluation and imaging',
      'Implant placement procedure',
      'Healing and osseointegration phase',
      'Final crown placement and review',
    ],
    duration: '3 to 6 months total',
    frequency: 'Planned follow-up schedule',
    faqs: [
      {
        question: 'Are dental implants safe?',
        answer: 'Implants are widely used and considered safe when done with proper planning.',
      },
      {
        question: 'How long do implants last?',
        answer: 'With oral hygiene and maintenance visits, implants can last many years.',
      },
    ],
  },
  {
    slug: 'root-canal-oral-surgery',
    title: 'Root Canal and Oral Surgery',
    shortDescription:
      'Endodontic and oral surgery solutions for infected, painful, or severely damaged teeth.',
    image: '/services/root.png',
    heroTitle: 'Root Canal and Oral Surgery Care',
    heroDescription:
      'Our team provides evidence-based treatment to remove infection, relieve pain, and protect surrounding oral tissues.',
    overview:
      'Root canal treatment removes infected pulp tissue and seals the tooth to prevent reinfection. Oral surgical procedures are planned when conservative care is insufficient.',
    benefits: [
      'Pain and infection control',
      'Preserves natural teeth where possible',
      'Prevents spread to surrounding tissues',
      'Supports long-term oral function',
    ],
    processSteps: [
      'Diagnosis with clinical and radiographic evaluation',
      'Root canal or surgical treatment planning',
      'Procedure under local anesthesia',
      'Post-treatment restoration and follow-up',
    ],
    duration: '60 to 120 minutes per sitting',
    frequency: 'As required by clinical condition',
    faqs: [
      {
        question: 'Is root canal treatment painful?',
        answer: 'With modern anesthesia, treatment is generally comfortable.',
      },
      {
        question: 'Will I need a crown after root canal?',
        answer: 'In many cases, a crown is recommended to protect the treated tooth.',
      },
    ],
  },
  {
    slug: 'periodontal-treatment',
    title: 'Periodontal Treatment',
    shortDescription:
      'Gum disease treatment to control infection and maintain healthy supporting tissues.',
    image: '/services/petridontal.png',
    heroTitle: 'Periodontal (Gum) Treatment',
    heroDescription:
      'Healthy gums are critical for long-term tooth stability. We provide structured gum care plans for every stage of periodontal disease.',
    overview:
      'Periodontal treatment includes deep cleaning, root surface debridement, and maintenance protocols to reduce inflammation and preserve teeth.',
    benefits: [
      'Reduces gum bleeding and swelling',
      'Controls progression of gum disease',
      'Helps prevent tooth mobility and loss',
      'Improves oral freshness and comfort',
    ],
    processSteps: [
      'Periodontal evaluation and charting',
      'Scaling and root planing phase',
      'Reassessment and home-care plan',
      'Maintenance visits at intervals',
    ],
    duration: '45 to 90 minutes',
    frequency: 'Maintenance every 3 to 6 months',
    faqs: [
      {
        question: 'What are early signs of gum disease?',
        answer: 'Bleeding gums, swelling, bad breath, and gum tenderness are common early signs.',
      },
      {
        question: 'Can gum disease be reversed?',
        answer: 'Early-stage gum disease can often be reversed with timely treatment and good home care.',
      },
    ],
  },
  {
    slug: 'teeth-scaling-polishing',
    title: 'Teeth Scaling and Polishing',
    shortDescription:
      'Professional cleaning to remove tartar and surface stains for healthier gums and fresher breath.',
    image: '/services/scaling.png',
    heroTitle: 'Teeth Scaling and Polishing Service',
    heroDescription:
      'Scaling removes hard deposits that regular brushing cannot. Polishing smoothens enamel surfaces and improves smile brightness.',
    overview:
      'Scaling and polishing is a preventive treatment recommended for plaque and tartar control. It supports gum health and helps prevent periodontal disease.',
    benefits: [
      'Removes tartar and plaque build-up',
      'Helps control gum inflammation',
      'Freshens breath and improves comfort',
      'Enhances oral hygiene outcomes',
    ],
    processSteps: [
      'Oral assessment and scaling plan',
      'Ultrasonic and manual deposit removal',
      'Polishing for smooth tooth surfaces',
      'Post-cleaning care instructions',
    ],
    duration: '45 to 60 minutes',
    frequency: 'Every 6 months or as advised',
    faqs: [
      {
        question: 'Does scaling make teeth weak?',
        answer: 'No, scaling removes harmful deposits and supports healthier gums and teeth.',
      },
      {
        question: 'Can I eat after scaling?',
        answer: 'You can eat after a short interval, following any instructions provided by your dentist.',
      },
    ],
  },
  {
    slug: 'crown-bridge-veneers',
    title: 'Crown, Bridge, Veneers',
    shortDescription:
      'Restorative and cosmetic options to strengthen damaged teeth and improve smile appearance.',
    image: '/services/crown.png',
    heroTitle: 'Crowns, Bridges and Veneers',
    heroDescription:
      'Custom restorations can repair fractured teeth, replace missing teeth, and deliver a balanced, natural smile design.',
    overview:
      'Crowns protect weakened teeth, bridges replace missing teeth, and veneers refine smile aesthetics. Each option is selected based on your oral condition and goals.',
    benefits: [
      'Strengthens and restores tooth structure',
      'Improves smile color and shape',
      'Enhances chewing function',
      'Durable and esthetic outcomes',
    ],
    processSteps: [
      'Examination and smile planning',
      'Tooth preparation and impressions',
      'Trial/temporary phase if needed',
      'Final cementation and bite adjustment',
    ],
    duration: '2 to 3 visits',
    frequency: 'Routine follow-up after placement',
    faqs: [
      {
        question: 'How long do crowns and veneers last?',
        answer: 'With care and regular dental reviews, they can last many years.',
      },
      {
        question: 'Are bridges better than implants?',
        answer: 'Both are useful options and selection depends on clinical requirements and preferences.',
      },
    ],
  },
  {
    slug: 'laser-dental-procedures',
    title: 'Laser Dental Procedures',
    shortDescription:
      'Minimally invasive laser-assisted dental procedures for precision and faster recovery.',
    image: '/services/laser.png',
    heroTitle: 'Laser Dentistry for Precise Treatment',
    heroDescription:
      'Laser-assisted procedures can improve comfort and healing for selected soft-tissue and periodontal indications.',
    overview:
      'Laser dentistry is used in selected procedures for high precision, reduced bleeding, and improved patient comfort compared to conventional methods in some cases.',
    benefits: [
      'Improved precision in selected treatments',
      'Potentially less bleeding and swelling',
      'Comfort-focused treatment experience',
      'Faster soft tissue recovery in many cases',
    ],
    processSteps: [
      'Suitability assessment for laser treatment',
      'Procedure planning and informed consent',
      'Laser-assisted intervention',
      'Aftercare and follow-up review',
    ],
    duration: 'Varies by procedure',
    frequency: 'As required by treatment plan',
    faqs: [
      {
        question: 'Is laser dentistry safe?',
        answer: 'Yes, when used by trained professionals with proper protocols.',
      },
      {
        question: 'Can all procedures be done with lasers?',
        answer: 'No, laser is used selectively based on indication and clinical need.',
      },
    ],
  },
  {
    slug: 'sleep-apnea-treatment',
    title: 'Sleep Apnea Treatment',
    shortDescription:
      'Custom oral appliance therapy to support airway function and improve sleep quality.',
    image: '/services/sleep.png',
    heroTitle: 'Dental Sleep Apnea Treatment',
    heroDescription:
      'For suitable patients, oral appliances can reduce snoring and improve nighttime breathing comfort.',
    overview:
      'Dental sleep appliances are custom devices designed to maintain airway openness during sleep. They are often used when medically appropriate and after proper evaluation.',
    benefits: [
      'Supports better nighttime breathing',
      'May reduce snoring intensity',
      'Portable and easy to maintain',
      'Comfortable alternative for selected cases',
    ],
    processSteps: [
      'Sleep concern consultation and screening',
      'Impressions and appliance design',
      'Delivery and fit adjustments',
      'Periodic review and maintenance',
    ],
    duration: '2 to 3 appointments',
    frequency: 'Periodic review visits',
    faqs: [
      {
        question: 'Do I need a diagnosis before appliance therapy?',
        answer: 'A proper sleep evaluation is recommended before starting therapy.',
      },
      {
        question: 'Can oral appliances help with snoring?',
        answer: 'Yes, they can reduce snoring in many suitable cases.',
      },
    ],
  },
];

export const treatmentSlugByTitle = treatments.reduce((acc, treatment) => {
  acc[treatment.title] = treatment.slug;
  return acc;
}, {});

export function getTreatmentBySlug(slug) {
  return treatments.find((item) => item.slug === slug) || null;
}

export function getTreatmentByTitle(title) {
  const slug = treatmentSlugByTitle[title];
  return getTreatmentBySlug(slug);
}
